import React, { useState, useEffect } from 'react';
import AddItem from './_AddItem.jsx';

export default class AddItemSection extends React.Component {
	constructor(props) {
		super(props);
        const {itemAdded, dispItemType, item} = this.props.data;
        let tmpItemAdded = [];
        tmpItemAdded[dispItemType] = itemAdded;

        this.state = {
            isShowingAddItem: (item.cnt <= 0)?true: (itemAdded.length > 0) ? true:false
        ,   tmpItemAdded: tmpItemAdded
        }

	}

    componentWillUnmount() {
        const {itemAdded, dispItemType} = this.props.data;
        let tmpItemAdded = [];
        tmpItemAdded[dispItemType] = itemAdded;
        this.setState({tmpItemAdded:tmpItemAdded});
    }

    saveItemAdded(itemAdded, itemType) {
        const {AddItemUtil, dispItemType} = this.props.data;
        let tmpItemAdded = this.state.tmpItemAdded;
        tmpItemAdded[itemType] = itemAdded;
        this.props.func.setItemAdded(tmpItemAdded, dispItemType);
        this.setState({tmpItemAdded: tmpItemAdded});
    }

    isShowingAddItemForm() {
        const {item} = this.props.data;
        return this.state.isShowingAddItem;
    }

    toggleShowingAddItemForm() {
        this.setState({isShowingAddItem:!this.state.isShowingAddItem});
    }

	render() {
        const {dispItemType} = this.props.data;
        const isShowingAddItemForm = this.isShowingAddItemForm();
        const strItemType = (dispItemType == "P") ? "parts" : (dispItemType == "S") ? "sets" : (dispItemType == "B") ? "books" : (dispItemType == "G") ? "gear" : (dispItemType == "M") ? "minifigures" : (dispItemType == "C") ? "catalogs" : "";
		const strItemTypeFull = (dispItemType == "P") ? "part" : (dispItemType == "S") ? "set" : (dispItemType == "B") ? "books" : (dispItemType == "G") ? "gear" : (dispItemType == "M") ? "minifigure" : (dispItemType == "C") ? "catalog" : "";
        
        return (
			<section className="personal-inventory__add-item personal-inventory__container-full-width">
				<div className="l-flex l-split">
					<div className="personal-inventory__add-item-title">
                        Add {(((dispItemType != "G") && (dispItemType != "B")) ? "a" : "")} {strItemTypeFull}
                        { (!isShowingAddItemForm) ?
                            <button className="l-margin-left--l" onClick={()=>this.toggleShowingAddItemForm()}><i className="fa-solid fa-circle-plus l-cursor-pointer personal-inventory__icon-plus-circle--top"/></button>
                            :
                            <button className="l-margin-left--l" onClick={()=>this.toggleShowingAddItemForm()}><i className="fa-regular fa-circle-minus l-cursor-pointer personal-inventory__icon-minus-circle--top"/></button>
                        }
                    </div>
					<div className="l-flex l-end--justify ">
						<div id="MPI-importExport-dropwdown" className="l-flex personal-inventory__import-export-box text--small" onClick={() => this.props.func.toggleImportExportMenu()}>
							<div>Import / Export</div>
							<div className="l-margin-left">
								<i className="fa-solid fa-caret-down"></i>
							</div>
						</div>
					</div>
				</div>
				<div className="personal-inventory__import-export-selector-container">
					<div className="personal-inventory__import-export-selector l-pad text--small">
						<div className="l-cursor-pointer l-border--bottom l-border--thick l-pad-bottom--sm" onClick={() => this.props.func.procImportExport("I")}>
							Import {strItemType} with CSV or XML file
						</div>
						<div className="l-cursor-pointer l-pad-top--sm" onClick={() => this.props.func.procImportExport("E")}>
							Export {strItemType} as XML file
						</div>
					</div>
				</div>
				
                {isShowingAddItemForm&&this.renderAddItemForm(dispItemType)}


			</section>

		)
    }

    renderAddItemForm(dispItemType) {
        const itemAdded = (this.state.tmpItemAdded[dispItemType] == null)?[]:this.state.tmpItemAdded[dispItemType];

        return (
            <AddItem key={dispItemType} data={{ myCollectionConfig: this.props.data.myCollectionConfig, itemAdded:itemAdded, itemType: dispItemType }} func={{saveItemAdded: (itemAdded, type)=>this.saveItemAdded(itemAdded, type), clearItemAdded: (type)=>this.props.func.clearItemAdded(type), reloadTriggerOn: () => this.props.func.reloadTriggerOn() }} />
        )
    }
}